import Modal from 'react-bootstrap/Modal';

import { ActionButton } from 'app/components/Button/ActionButton';
import Typography from 'app/components/Typography';

import { ModalContainer } from 'app/modules/inventory/items/components/ItemStatusModal';

interface Props {
  open: boolean;
  onCancel: () => void;
}

const UnableInactiveItemModal = ({ open, onCancel }: Props) => {
  return (
    <ModalContainer show={open} onHide={onCancel} centered animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <Typography variant="heading-6">Unable to inactive item</Typography>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Typography variant="body-3">
          To inactive this item, it has to be removed from all the bins.
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <ActionButton
          labelButtonSubmit="Cancel"
          onSubmit={onCancel}
          onCancel={onCancel}
          isShowButtonReset={false}
        />
      </Modal.Footer>
    </ModalContainer>
  );
};

export default UnableInactiveItemModal;
